//@ts-nocheck
import "./stepper.css";
import clsx from "clsx";
import React, { useState } from "react";
import {
  StepperProps,
  StepperBodyProps,
  StepperTitleProps,
  StepperContentProps,
} from "../@types/stepper";
import { useEffect } from "react";
import { Typography } from "../index";
import {isEqual} from "../../../lib/utils";

function Stepper(props: StepperProps) {
  const {
    titles,
    body,
    className,
    active,
    getActive,
    clickable,
    titleTextType,
  } = props;

  const [activeIndex = 0, setActiveIndex] = useState();

  useEffect(() => {
    setActiveIndex(active);

  }, [active]);

  useEffect(() => {
    getActive?.(activeIndex);

  }, [activeIndex]);

  const handleChangeStep = (index) => {
    if (clickable) {
      setActiveIndex(index);
    }
  };

  return (
    <React.Fragment>
      <div className={clsx("mb-4", className)}>
        <div className="row">
          <div className="col">
            <div
              className="timeline-steps aos-init aos-animate"
              data-aos="fade-up"
            >
              {titles.map(function (item, index) {
                return (
                  <div
                    key={index}
                    className="timeline-step"
                    onClick={() => handleChangeStep(index)}
                  >
                    <div
                      className={clsx(
                        "timeline-content",
                        index <= activeIndex && "fill",
                        isEqual(index , 0) && "fill"
                      )}
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      title=""
                      data-content="And here's some amazing content. It's very engaging. Right?"
                      data-original-title="2003"
                    >
                      <div className="inner-circle"></div>
                      <Typography
                        type={titleTextType || "h6"}
                        className=" mt-3 mb-1"
                      >
                        {item.title}
                      </Typography>
                      <p className="h6 text-muted mb-0 mb-lg-0">
                        {item.subtitle}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {body[activeIndex]}
    </React.Fragment>
  );
}

/*const StepperItem = (props: StepperHeadProps) => {
  const { children, getActive } = props;

  const [activeIndex, setActiveIndex] = useState("0");

  const items = useMemo(() => {
    const list = React.Children.toArray(children);
    const title = [];
    const body = [];
    for (let i in list) {
      if (list[i]?.type === StepperTitle) {
        const { children } = list[i].props;
        title.push(
          <StepperTitle
            key={i}
            {...list[i].props}
            children={list[i].props.children}
          />
        );
      } else if (list[i]?.type === StepperContent) {
        body.push(list[i].props.children);
      }
    }

    return { title };
  }, [children, activeIndex]);

  const onSelectStep = ({ index }) => {
    setActiveIndex(index);
    getActive?.(index);
  };

  return;
};*/

const StepperBody = (props: StepperBodyProps) => {
  const { children, id, active = "0" } = props;

  const [content, setContent] = useState<[]>([]);

  useEffect(() => {
    getElement();

  }, [active]);

  const getElement = () => {
    const list = React.Children.toArray(children);
    const contentList = [];

    for (let i in list) {
      if (list[i]?.type?.name === "StepperContent") {
        const { children } = list[i].props;
        contentList.push(
          <StepperContent
            id={id}
            key={i}
            active={active === i}
            targetId={`#${id}-${i}`}
          >
            {children}
          </StepperContent>
        );
      }
    }

    setContent(contentList);
  };
  return !content.length ? <div /> : <React.Fragment>{content}</React.Fragment>;
};

const StepperTitle = (props: StepperTitleProps) => {
  const { isActive, title, subtitle } = props;
  return (
    <div
      onClick={() => handleChangeStep(index)}
      className="timeline-step overflow-x-hidden hideScroll"
    >
      <div
        className={clsx("timeline-content", isActive && "fill")}
        data-toggle="popover"
        data-trigger="hover"
        data-placement="top"
        title=""
      >
        <div className="inner-circle" />
        <p className="h6 mt-3 mb-1">{title}</p>
        <p className="h6 text-muted mb-0 mb-lg-0">{subtitle}</p>
      </div>
    </div>
  );
};

const StepperContent = (props: StepperContentProps) => {
  return <div />;
};

Stepper.Body = StepperBody;
Stepper.Title = StepperTitle;
Stepper.Content = StepperContent;

export default Stepper;
